<span class="eidos-icon-host" *ngIf="iconConfiguration" [ngClass]="{'clickable': iconClickable, 'has-badge': !!iconBadge}">
  <ng-container [ngSwitch]="iconConfiguration.iconType">
    <i *ngSwitchCase="EidosIconType.Awesome" class="eidos-icon fa {{ getFAValue() }}"
      [style.transform]="iconScale"
      [tooltipDrawer]="iconTooltip" trigger="hover" [position]="iconTooltipPosition"></i>
    <img *ngSwitchCase="EidosIconType.SVG"
      class="eidos-icon eidos-svg-icon"
      [ngClass]="getSvgScale('*')"
      [src]="getSvgSrc()"
      [alt]="iconConfiguration.iconCode"
      [tooltipDrawer]="iconTooltip" trigger="hover"
      [position]="iconTooltipPosition" />
    <img *ngSwitchCase="EidosIconType.MyBiz" [src]="iconConfiguration.iconCodeSafeUrl" alt="">
    <i *ngSwitchDefault class="eidos-icon fa {{ getFAValue() }}"
      [style.transform]="iconScale"
      [tooltipDrawer]="iconTooltip" trigger="hover" [position]="iconTooltipPosition"></i>
  </ng-container>
  <span *ngIf="iconBadge" class="eidos-icon-badge" aria-hidden="true">{{ iconBadge }}</span>
</span>
